import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {DEFAULT_PAGE_SIZES} from 'src/hooks/common-data-service/cached-table';

import {PaginationStripe} from '@pb/kit-component-pagination';

import type {ActionCreatorWithPayload} from '@reduxjs/toolkit';
import type {Pagination} from 'src/openapi/admin/models/Pagination';
import type {AppState} from 'src/store/typedef';

type StateActions = {
    setPageSize: ActionCreatorWithPayload<number>,
    setCurrentPage: ActionCreatorWithPayload<number>,
};

type StateSelector = (state: AppState) => {pagination: Pagination};

type Props = {
    totalCount: number,
    stateActions: StateActions,
    stateSelector: StateSelector,
};

export const EntitlementsPagination = ({totalCount, stateActions, stateSelector}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(stateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(stateActions.setPageSize(pageSize));
        dispatch(stateActions.setCurrentPage(1));
    }, [dispatch, stateActions]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(stateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch, stateActions]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={DEFAULT_PAGE_SIZES}
        />
    );
};
